import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";

import { eventCallbacks } from "./handcrafted/CrfCallbacks";

//custom components
import CustomDatePicker from "./components/CustomDatePicker2";
import AnswerOptionsSm from "./components/AnswerOptionsSm";
import VisualAnalogueScale from "./components/VisualAnalogueScale";
import Eq5d from "./components/Eq5d";
import DynamicCrf from "./components/DynamicCRF";
import FormCompletionLogin from "./components/FormCompletionLogin";
import AlertMessage from "./components/AlertMessage";
import LookupServicePlaces from "./components/LookupServicePlaces";
import SessionExpiredMessage from "./components/SessionExpiredMessage";

//register custom components globally so that they can be nested
Vue.component("custom-date-picker", CustomDatePicker);
Vue.component("answer-options-sm", AnswerOptionsSm);
Vue.component("visual-analogue-scale", VisualAnalogueScale);
Vue.component("eq5d", Eq5d);
Vue.component("dynamic-crf", DynamicCrf);
Vue.component("data-entry-login", FormCompletionLogin);
Vue.component("alert-message", AlertMessage);
Vue.component("session-expired-message", SessionExpiredMessage);

Vue.component("lookup-service-places", LookupServicePlaces);

Vue.config.productionTip = false;

Vue.config.errorHandler = (err, vm, info) => {
    // err: error tryace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    //debugger;
    //console.log("ERROR", err, info);
    let eData = {
        error: err.message,
        info: info,
        stack: err.stack,
    };
    axios.post("api/DynamicCrf/LogClientError", eData);
};

router.beforeEach(async (to, from, next) => {
    //debugger;
    if (to.query.id) {
        await store.dispatch("getLinkStatus", to.query.id);
        if (store.getters.getLinkStatus != 1) {
            //link is inactive
            store.commit("clearFormLinkCache");
            return next({
                name: "alert-message",
            });
        }
    }

    //block navigation-to if the setStepNotSavedMsg flag is active
    if (store.getters.getFormHasUnsavedChanges) {
        store.commit("setStepNotSavedMsg", true);
        next(false);
    }

    if (to.matched.length != 1) {
        return next();
    }

    let route = to.matched[0];
    if (!route.meta.eventID) route.meta.eventID = to.query.formGroupId;

    route.meta.formGuid = to.query.id;

    let eventID = route.meta.eventID;

    if (eventID == 10) {
        if (store.getters.getFormAuthenticated != 10) {
            store.commit("resetDataEntry");
        }
        //initialise event & create menu
        eventCallbacks[10].onLoad.call(router, route, next);
    } else if (to.path == "/data-entry-login") {
        //PIN validation
        const pin = store.getters.getDataEntryPin;

        if (pin) {
            const pinStatus = await store.dispatch("getPinStatus", { pin, guid: to.query.id });
            if (pinStatus != 0) {
                store.commit("resetDataEntry");
                return next({ name: "session-expired-message" });
            } else {
                if (to.query.formGroupId != store.getters.getFormAuthenticated) {
                    store.commit("clearCurrentRoutePath");
                    store.commit("clearMenuItems");
                }
                eventCallbacks[eventID].onLoad.call(router, route);
            }
        } else {
            return next();
        }
    } else {
        return next();
    }
});

new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
